export default __webpack_public_path__ + "static/media/OEKOTEX CERTIFICATE_2022_2023.969209dc.jpg";